import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import Swal from 'sweetalert2';

import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { BundleService } from '../../../../services/bundles';

@Component({
  selector: 'app-allbundles',
  templateUrl: './allbundles.component.html',
  styleUrls: ['./allbundles.component.scss']
})
export class AllbundlesComponent implements OnInit, AfterViewInit {

  dataSource = new MatTableDataSource<any>([]);

  displayedColumns: string[] = [
    'name_en',
    'name_ar',
    'components',
    'price',
    'affiliationprice',
    'pricea',
    'priceb',
    'pricec',
    'actions'
  ];
  warehouseId: number | null = null;
  totalItems = 0;
  page = 1;
  perPage = 10;
  totalBundles = 0;
  lowestPrice = 0;
  highestPrice = 0;
  contentReady = false;
  noData = false;
  isMobile = false;
  isAr = localStorage.getItem('language') === 'ar';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private _bundleService: BundleService,
    private router: Router,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();

    const posId = localStorage.getItem('posId');
    this.warehouseId = posId ? Number(posId) : null;
    this.getBundles(this.warehouseId);
  } 

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  getBundles(warehouse_id:any) {
    this.contentReady = true;

    this._bundleService.getAll(warehouse_id,this.page, this.perPage).subscribe({
      next: (res) => {
        const data = res.data || [];
        this.dataSource.data = res.data;
        this.totalItems = res.total;
        this.noData = res.data.length === 0;
        this.totalBundles = res.stats.total_bundles;
        this.lowestPrice = res.stats.lowest_price;
        this.highestPrice = res.stats.highest_price;
        this.contentReady = false;
      },
      error: () => {
        this.contentReady = false;
        this.noData = true;
      }
    });
  }

  applyFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.perPage = event.pageSize;
    this.getBundles(this.warehouseId );
  }

  edit(bundle: any) {
    this.router.navigate(['/addbundle'], { queryParams: bundle });
  }

  delete(bundleId: number) {
    Swal.fire({
      title: this.isAr ? 'متأكد؟' : 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'نعم' : 'Yes',
      cancelButtonText: this.isAr ? 'لا' : 'No'
    }).then(result => {
      if (result.isConfirmed) {
        this._bundleService.delete(bundleId).subscribe(() => {
          Swal.fire('Deleted!', '', 'success');
          this.getBundles(this.warehouseId );
        });
      }
    });
  }

  fixImage(img: string) {
    return img
      ? 'https://backendproduction.blueboxpet.com/storage/app/public/' + img
      : '/assets/no-image.png';
  }
}
